
import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'
import { MedicalAppointmentFormData } from 'components/MedicalRequestForm/schema'
import { Controller, useFormContext } from 'react-hook-form'
import { CustomRadioButton } from '../CustomRadioButton'
import * as S from '../../styles'
export const SessionQuantityRadio = () => {
  const { control } = useFormContext<MedicalAppointmentFormData>()

  return (
    <S.QuantityRadioContainer>
      <Typography variant="content2" weight='bold'>
        A quantidade de sessões foi definida no pedido médico? *
      </Typography>
      <S.WrapperField>
        {['true', 'false'].map((value) => (
          <Controller
            key={value}
            control={control}
            name="hasSessionQuantity"
            render={({ field, fieldState: { error } }) => (
              <CustomRadioButton
                {...field}
                id={value}
                onChange={() => field.onChange(value)}
                label={<Typography variant="content2">{value === 'true' ? 'Sim' : 'Não'}</Typography>}
                hasError={Boolean(error?.message)}
              />
            )}
          />
        ))}
      </S.WrapperField>
    </S.QuantityRadioContainer>
  )
}
